import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './GamesPage.module.css';
import BottomNavBar from '../components/BottomNavBar';
import InstructionCard from '../components/InstructionCard';
import LivesDisplay from '../components/LivesDisplay';
import { GAME_CONFIGS } from '../constants/gameConfig';
import { isGameUnlocked, getXP } from '../utils/questUtils';

const GamesPage: React.FC = () => {
  const [currentXP, setCurrentXP] = useState(0);

  useEffect(() => {
    // Get current XP on component mount
    setCurrentXP(getXP());
  }, []);

  return (
    <div className={styles.container} style={{ paddingBottom: 200 }}>
      <h1 className={styles.title}>Games</h1>
      <LivesDisplay />
      <InstructionCard
        title="Play"
        content={[
          "Earn lives by completing real-world quests that save you money.",
          "Use your lives to play. Earn more by completing quests and leveling up!",
          "Some games unlock as you level up - keep completing quests to unlock them all!"
        ]}
        emoji="🎮"
        storageKey="games_instructions_dismissed"
      />
      <div className={styles.gamesContainer}>
        {GAME_CONFIGS.map((game) => {
          const unlocked = isGameUnlocked(game.unlockXP);
          const xpNeeded = game.unlockXP - currentXP;

          return (
            <div
              key={game.id}
              className={styles.gameCard}
              style={{
                opacity: unlocked ? 1 : 0.7,
                position: 'relative',
              }}
            >
              {!unlocked && (
                <div style={{
                  position: 'absolute',
                  top: 12,
                  right: 12,
                  background: '#ef4444',
                  color: 'white',
                  padding: '4px 10px',
                  borderRadius: '6px',
                  fontSize: '0.85rem',
                  fontWeight: 600,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 4,
                  zIndex: 1,
                }}>
                  🔒 Locked
                </div>
              )}
              <h2 className={styles.gameTitle}>{game.emoji} {game.title}</h2>
              <p className={styles.gameDescription}>{game.description}</p>

              {!unlocked && (
                <p style={{
                  color: '#7c3aed',
                  fontWeight: 600,
                  fontSize: '0.95rem',
                  marginTop: '8px',
                  marginBottom: '8px',
                }}>
                  Unlock at Level {game.unlockLevel} ({game.unlockXP} XP)
                  <br />
                  <span style={{ fontSize: '0.85rem', color: '#6b7280' }}>
                    {xpNeeded} XP needed
                  </span>
                </p>
              )}

              {unlocked ? (
                <Link to={game.route}>
                  <button className={styles.playButton}>
                    Play
                  </button>
                </Link>
              ) : (
                <button
                  className={styles.playButton}
                  disabled
                  style={{
                    opacity: 0.5,
                    cursor: 'not-allowed',
                    background: '#9ca3af',
                  }}
                >
                  Locked
                </button>
              )}
            </div>
          );
        })}
      </div>
      <BottomNavBar />
    </div>
  );
};

export default GamesPage; 